import { Button } from "@swivl-mono/ui";

import "./RefreshModal.scss";

const RefreshModal = () => {
  const refreshClicked = () => {
    window.location.reload();
  };

  return (
    <div className="RefreshModal flex flex-col items-center gap-2">
      <span className="text-2xl">⏰</span>
      <h2 className="font-poppins text-lg font-semibold">Session Expired</h2>
      <span className="font-poppins text-lg">Please refresh to continue.</span>

      <div className="buttons">
        <Button onClick={refreshClicked}>Let's Do This!</Button>
      </div>
    </div>
  );
};

export default RefreshModal;
